<template>
  <div
    class="rounded-lg bg-white dark:bg-gray-900  mb-2 sm:mb-4 px-2 sm:px-3 md:px-4 lg:px-6"
  >
    <!-- Mobile: Compact layout -->
    <div class="sm:hidden flex items-center justify-between h-10 overflow-x-auto mx-auto">
      <!-- Navigation links for mobile -->
      <div class="flex items-center gap-3 flex-nowrap">
        <router-link
          v-for="item in visibleItems"
          :key="item.path"
          :to="item.path"
          class="text-sm font-medium transition-colors whitespace-nowrap flex-shrink-0"
          :class="isCurrentPath(item.path)
            ? 'text-indigo-600 dark:text-indigo-400 border-b-2 border-indigo-600 dark:border-indigo-400 pb-1'
            : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'"
        >
          {{ item.label }}
        </router-link>
      </div>

      <!-- Spacer for alignment -->
      <div class="w-12" />
    </div>

    <!-- Desktop: Full layout -->
    <div class="hidden sm:flex items-center justify-start h-12">
      <!-- Navigation Tabs -->
      <div class="flex items-center space-x-6 md:space-x-8">
        <router-link
          v-for="item in visibleItems"
          :key="item.path"
          :to="item.path"
          class="text-sm font-medium transition-colors px-1"
          :class="isCurrentPath(item.path)
            ? 'text-indigo-600 dark:text-indigo-400 border-b-2 border-indigo-600 dark:border-indigo-400 pb-1'
            : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'"
        >
          {{ item.label }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

interface NavItem {
  path: string;
  label: string;
  condition?: boolean;
}

interface Props {
  items: NavItem[];
}

const props = defineProps<Props>();
const route = useRoute();

const isCurrentPath = (path: string) => {
  return route.path === path || route.path.startsWith(path + '/');
};

const visibleItems = computed(() => {
  return props.items.filter(item => item.condition !== false);
});
</script>
